const numberFormat = (value) => {
  if(isNaN(value)) return "-";
  if(value === null) return "-";
  let formatter = new Intl.NumberFormat("ja-JP");
  return formatter.format(value);
};

export default numberFormat;
